!function() {
    const chekly = {
        cfg: {
            dataAttrAppUrl: "data-chekly-url",
            dataAttrCheckout: "chekly-procceded",
            dataAttrCustomDomain: "data-checkout-domain",
            dataAttrCheckoutTheme: "data-chekly-theme",
            defaultAppBaseUrl: "https://chekly-app.com"
        },
        vars: { isCheckoutProcessing: false },
        
        helpers: {
            getCookie(t) {
                const e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
                return e ? decodeURIComponent(e[1]) : void 0
            },
            setCookieWithExpire(t, e, o) {
                const n = new Date(Date.now() + 864e5 * o).toUTCString();
                document.cookie = `${t}=${e}; expires=${n}; path=/;`;
            }
        },

        functions: {
            getAppBaseUrl() {
                const e = document.querySelector("[" + chekly.cfg.dataAttrAppUrl + "]");
                if (!e) return chekly.cfg.defaultAppBaseUrl;
                return e.getAttribute(chekly.cfg.dataAttrCustomDomain) || e.getAttribute(chekly.cfg.dataAttrAppUrl) || chekly.cfg.defaultAppBaseUrl;
            },
            getCartToken: () => chekly.helpers.getCookie("cart"),
            
            processCheckout() {
                if (chekly.vars.isCheckoutProcessing) return;
                const cartToken = chekly.functions.getCartToken();
                if (!cartToken) {
                    fetch('/cart.js').then(r => r.json()).then(cart => {
                        if (cart.token) chekly.functions.executeRedirect(cart.token);
                        else window.location = "/checkout";
                    });
                } else {
                    chekly.functions.executeRedirect(cartToken);
                }
            },

            executeRedirect(token) {
                chekly.vars.isCheckoutProcessing = true;
                const baseUrl = chekly.functions.getAppBaseUrl();
                const shop = window.Shopify?.shop || window.location.hostname;
                const rate = window.Shopify?.currency?.rate || "1";
                const theme = document.querySelector("[" + chekly.cfg.dataAttrAppUrl + "]")?.getAttribute(chekly.cfg.dataAttrCheckoutTheme) || "";
                
                let trackingParams = "";
                try {
                    const saved = JSON.parse(chekly.helpers.getCookie("chekly_tracking") || "{}");
                    trackingParams = Object.keys(saved).map(k => `${k}=${encodeURIComponent(saved[k])}`).join("&");
                } catch(e) {}

                let checkoutUrl = `${baseUrl}/checkout/?storeName=${shop}&cartToken=${token}&curRate=${rate}${theme ? `&theme=${theme}` : ""}`;
                if (trackingParams) checkoutUrl += `&${trackingParams}`;
                
                window.location = checkoutUrl;
            }
        },

        init() {
            const urlParams = new URLSearchParams(window.location.search);
            const utms = {};
            ["utm_campaign", "utm_medium", "utm_source", "utm_content", "utm_term", "fbclid", "gclid", "ttclid"].forEach(p => {
                if (urlParams.get(p)) utms[p] = urlParams.get(p);
            });
            if (Object.keys(utms).length) chekly.helpers.setCookieWithExpire("chekly_tracking", JSON.stringify(utms), 7);

            document.addEventListener("click", (e) => {
                const target = e.target.closest('button[name="checkout"], [href*="/checkout"], .checkout-button, .cart__checkout-button');
                
                if (target) {
                    if (target.closest('form[action^="/cart/add"]')) return;

                    e.preventDefault();
                    e.stopImmediatePropagation();
                    chekly.functions.processCheckout();
                }
            }, true);

            document.addEventListener("submit", (e) => {
                if (e.target.action?.includes("/cart") && !e.target.action?.includes("/cart/add")) {
                    const isCheckout = e.submitter?.name === "checkout" || e.target.querySelector('[name="checkout"]');
                    if (isCheckout) {
                        e.preventDefault();
                        chekly.functions.processCheckout();
                    }
                }
            }, true);
            
            window.addEventListener("pageshow", () => { chekly.vars.isCheckoutProcessing = false; });
        }
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => chekly.init());
    } else {
        chekly.init();
    }
}();